import styled from '@emotion/styled';
import { alpha } from '@mui/material';

import TimelineIcon from '@mui/icons-material/Timeline';

const NoTimelineContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.2rem;
  padding: 2.2rem 2rem;
  text-align: center;
  background: linear-gradient(
    135deg,
    ${props => alpha(props.theme.colors.primaryLighten, 0.04)} 0%,
    ${props => alpha(props.theme.colors.primary, 0.08)} 100%
  );
  border: 2px dashed ${props => alpha(props.theme.colors.border, 0.6)};
  border-radius: 12px;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    border-color: ${props => alpha(props.theme.colors.primaryMid, 0.4)};
    background: linear-gradient(
      135deg,
      ${props => alpha(props.theme.colors.primaryLighten, 0.06)} 0%,
      ${props => alpha(props.theme.colors.primary, 0.12)} 100%
    );
  }
`;

const IconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background: ${props => alpha(props.theme.colors.primaryMid, 0.1)};
  border: 2px solid ${props => alpha(props.theme.colors.primaryMid, 0.2)};
`;

const EmptyStateTitle = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${props => props.theme.colors.text};
  margin-bottom: 0.3rem;
`;

const EmptyStateSubtitle = styled.div`
  font-size: 1.1rem;
  color: ${props => props.theme.colors.mildText};
  line-height: 1.4;
  max-width: 24rem;
`;

const NoTimeline = ({title = 'No Timeline History', subtitle = 'Activity and notes will appear here as they are updated'}) => {
  return (
    <NoTimelineContainer>
      <IconWrapper>
        <TimelineIcon 
          sx={{ 
            fontSize: "2.2rem", 
            color: theme => alpha(theme.colors?.primaryMid, 0.7)
          }} 
        />
      </IconWrapper>
      <div>
        <EmptyStateTitle>{title}</EmptyStateTitle>
        <EmptyStateSubtitle>
          {subtitle}
        </EmptyStateSubtitle>
      </div>
    </NoTimelineContainer>
  );
};

export default NoTimeline;